export * from './share-map.component';
export * from './share-map-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/share-map/share-map/index.ts